import React, { Component } from 'react';
import './ResetPassword';

import axios from 'axios';
import {FiChevronLeft} from 'react-icons/fi';
import resetPasswordImg from '../../assets/img/resetPassword.jpg';
import resetSuccessfulImg from '../../assets/img/transactionSuccess.png';
import Header from '../../components/partials/HeaderComponent';
import Footer from '../../components/partials/FooterComponent';

function validateEmail(email) {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
}

function validatePassword(password) {
    const regex_pass = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!#%*?&]{8,20}$/;
    return regex_pass.test(password);
}

class ResetPassword extends Component {
    state = {
        email: "",
        emailError: false,
        passwordError: false,
        password1: "",
        password2: "",
        emailErrorMessage: "Invalid email address",
        passwordErrorMessage: "",
        didPasswordReset: false
    }

    componentDidMount() {
        localStorage.removeItem("Codeium__Username")
    }

    changeEmailHandler = (event) => {
        const email = event.target.value;
        if(validateEmail(email)) {
            this.setState({
                emailError: false
            })
        }
        this.setState({
            email: email
        })
    }

    changePasswordHandler = (event, passwordNo) => {
        const password = event.target.value;
        let passwordState = "password1";
        if(passwordNo === 2) {
            passwordState = "password2";
        }
        if(passwordNo === 1 && this.state.password2 === password) {
            this.setState({
                passwordError: false
            })
        } else if(passwordNo === 2 && this.state.password1 === password) {
            this.setState({
                passwordError: false
            })
        }
        this.setState({
            [passwordState]: password
        })
    }

    formSubmitHandler = (event) => {
        event.preventDefault();
        if(!validateEmail(this.state.email)) {
            this.setState({
                emailError: true,
            })
        } else if(this.state.password1 !== this.state.password2) {
            this.setState({
                passwordError: true,
                passwordErrorMessage: "Passwords don't match"
            })
        } else if(!validatePassword(this.state.password1)) {
            this.setState({
                passwordError: true,
                passwordErrorMessage: 'Password must have at least 1 number 1 uppercase and lowercase character, 1 special symbol and between 8 to 20 characters'
            });
        } else
        {
            axios.post('https://server.codeium.tech/password/update', {
                email_id: this.state.email,
                password: this.state.password1,
                cpassword: this.state.password2
            }).then(res => {
                if(res.data.status === 415) {
                    this.setState({
                        passwordError: true,
                        passwordErrorMessage: "Invalid Credentials"
                    })
                } else if(res.data.status === 420){
                    this.setState({
                        passwordError: true,
                        passwordErrorMessage: "Some Error Occurred! Please try again"
                    })
                } else {
                    this.setState({
                        didPasswordReset: true
                    })
                }
            }).catch(err => {
                // console.log(err);
            })
        }
    }

    render() {
        return (
            <>
                <Header />
                <div className="container my-5">
                    <div className="row">
                        <div className="col-12 d-flex justify-content-center">
                            <div className="CustomCard1 d-flex flex-column align-items-center">
                                {
                                    this.state.didPasswordReset ? (
                                        <>
                                            <div style={{paddingLeft: '0', width: '100px'}} className="ImgContainer">
                                                <img src={resetSuccessfulImg} />
                                            </div>
                                            <h4 className="mt-3 text-bold">
                                                Password Reset Successfully
                                            </h4>
                                            <a href="/">
                                                <button className="btn BackLogin mt-1 mb-4"> 
                                                    <FiChevronLeft style={{fontSize: '18px', fontWeight: 'bold'}} className="mb-1"/>Back to Login
                                                </button>
                                            </a>
                                        </>
                                    ) : (
                                        <>
                                            <div className="ImgContainer">
                                                <img src={resetPasswordImg} />
                                            </div>
                                            <h5><b>Reset Password</b></h5>
                                            <p className="text-muted text-center line-height-1rem mt-2" >Enter your email and create new password</p>
                                            <form onSubmit={this.formSubmitHandler} className="mt-3 d-block ForgotPasswordForm">
                                                <h6 className="Input-Label">Email</h6>
                                                <div class="form-group">
                                                    <input value={this.state.email} onChange={this.changeEmailHandler} type="email" class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" placeholder="Enter your email" />
                                                    {
                                                        this.state.emailError ? (
                                                            <div class="invalid-feedback">
                                                                {this.state.emailErrorMessage}
                                                            </div>
                                                        ) : null
                                                    }
                                                </div>
                                                <h6 className="Input-Label">New Password</h6>
                                                <div class="form-group">
                                                    <input value={this.state.password1} onChange={(event) => this.changePasswordHandler(event, 1)} type="password" class="form-control" aria-describedby="emailHelp" placeholder="Enter your Password" />
                                                </div>
                                                <h6 className="Input-Label">Confirm New Password</h6>
                                                <div class="form-group">
                                                    <input value={this.state.password2} onChange={(event) => this.changePasswordHandler(event, 2)} type="password" class="form-control" aria-describedby="emailHelp" placeholder="Confirm Password" />
                                                    {
                                                        this.state.passwordError ? (
                                                            <div class="invalid-feedback">
                                                                <p className="line-height-1rem mt-2">{this.state.passwordErrorMessage}</p>
                                                                
                                                            </div>
                                                        ) : null
                                                    }
                                                </div>
                                                <button type="submit" className="btn btn-info btn-block mt-4 mb-2">
                                                    Submit
                                                </button>
                                            </form>
                                            <a href="/">
                                                <button className="btn BackLogin mt-1 mb-4"> 
                                                    <FiChevronLeft style={{fontSize: '18px', fontWeight: 'bold'}} className="mb-1"/>Back to Login
                                                </button>
                                            </a>
                                        </>
                                    )
                                }
                                
                            </div>
                        </div>
                    </div>
                </div>
                <Footer />
            </>
        )
    }
}

export default ResetPassword;